import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportMealPlanToPDF = async (meals, shoppingList = [], planTitle = "SousChef_Plan") => {
  console.log("=== PDF EXPORT DEBUG START ===");

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 14;
  const contentWidth = pageWidth - (margin * 2);

  const addHeader = (title, subtitle) => {
    doc.setFontSize(22);
    doc.setTextColor(15, 23, 42);
    doc.text(title, margin, 25);
    if (subtitle) {
      doc.setFontSize(10);
      doc.setTextColor(100, 116, 139);
      doc.text(subtitle, margin, 32);
    }
  };

  // 1. Page 1: Overview Table
  addHeader(planTitle || "Your Executive Chef's Menu", `Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`);

  const tableRows = meals.map(m => [
    m.day,
    m.meal_type,
    m.name,
    `${m.calories} kcal`,
    `${m.protein}g P`,
    `${m.carbs}g C`,
    `${m.fat}g F`
  ]);

  autoTable(doc, {
    startY: 40,
    head: [['Day', 'Type', 'Meal Name', 'Cals', 'Prot', 'Carb', 'Fat']],
    body: tableRows,
    theme: 'striped',
    headStyles: { fillColor: [51, 65, 85] },
    styles: { fontSize: 9, cellPadding: 3 },
    columnStyles: {
      0: { fontStyle: 'bold' },
      2: { cellWidth: 50 }
    }
  });

  // 2. Subsequent Pages: Detailed Culinary Instructions
  doc.addPage();
  addHeader("Culinary Instructions", "Step-by-step preparation for your weekly menu");

  let currentY = 45;

  meals.forEach((meal, index) => {
    const title = `${meal.day}: ${meal.name}`;
    const instructions = meal.instructions || "No specific instructions provided.";

    if (currentY + 30 > pageHeight - 20) {
      doc.addPage();
      currentY = 25;
    }

    doc.setFontSize(14);
    doc.setTextColor(30, 41, 59);
    doc.setFont(undefined, 'bold');
    doc.text(title, margin, currentY);
    currentY += 8;

    doc.setFontSize(10);
    doc.setTextColor(71, 85, 105);
    doc.setFont(undefined, 'normal');

    const splitText = doc.splitTextToSize(instructions, contentWidth);
    doc.text(splitText, margin, currentY);
    currentY += (splitText.length * 5) + 12;
  });

  // 3. Final Page: Shopping List
  if (shoppingList && shoppingList.length > 0) {
    doc.addPage();
    addHeader("Kitchen Shopping List", "Missing ingredients to pick up");

    const shoppingRows = shoppingList.map(item => {
      if (typeof item === 'string') return [item];
      return [`${item.qty || ''} ${item.unit || ''} ${item.name || ''}`.trim()];
    });

    autoTable(doc, {
      startY: 40,
      head: [['Missing Ingredient']],
      body: shoppingRows,
      theme: 'plain',
      headStyles: { fillColor: [248, 250, 252], textColor: [71, 85, 105] },
      styles: { fontSize: 11, cellPadding: 4 },
      alternateRowStyles: { fillColor: [252, 252, 252] }
    });
  }

  // 4. Generate filename and PDF data
  const baseName = planTitle || `Meal_Plan_${new Date().toISOString().split('T')[0]}`;
  const cleanTitle = baseName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  const fileName = `${cleanTitle}_${new Date().toISOString().split('T')[0]}.pdf`;

  console.log("Generated filename:", fileName);

  const pdfBlob = doc.output('blob');
  console.log("PDF blob size:", pdfBlob.size);

  // 5. Use File System Access API (Chrome's native save dialog)
  // This is the most reliable method for Chrome users
  if ('showSaveFilePicker' in window) {
    console.log("Using File System Access API...");
    try {
      const handle = await window.showSaveFilePicker({
        suggestedName: fileName,
        types: [{
          description: 'PDF Document',
          accept: { 'application/pdf': ['.pdf'] }
        }]
      });

      const writable = await handle.createWritable();
      await writable.write(pdfBlob);
      await writable.close();

      console.log("File saved successfully via File System Access API!");
      console.log("=== PDF EXPORT DEBUG END ===");
      return;
    } catch (err) {
      // User cancelled the save dialog, or API failed
      console.log("File System Access API failed or cancelled:", err.message);
      // Fall through to legacy method
    }
  }

  // 6. Fallback: Traditional anchor method
  console.log("Using fallback anchor method...");
  const link = document.createElement('a');
  link.href = URL.createObjectURL(new Blob([pdfBlob], { type: 'application/octet-stream' }));
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }, 1000);

  console.log("=== PDF EXPORT DEBUG END ===");
};